export default "__VITE_ASSET__txHPNrnC__"